import { useEffect, useState } from "react"
import { useParams } from "react-router";
import { getSchedules } from "../../../../scripts/schedules";
import { getZones } from "../../../../scripts/zone";
import TopNavigation from '../../../navigation/TopNavigation';
import ViewHeader from '../../../UiComponents/ViewHeader';
import ScheduleItem from "./ScheduleItem";
import ScheduleMenu from "./ScheduleMenu";

const ScheduleView = props => {
    let { id } = useParams();
    const [zones, setZones] = useState();
    const [schedules, setSchedules] = useState();
    const [filter, setFilter] = useState();
    const [filteredSchedules, setFilteredSchedules] = useState(props.schedules);

    useEffect(() => {
        getDataHandler();
        if (filter) {
            onSetFilter(filter);
        }
    }, []);

    const onSetFilter = newFilter => {
        setFilter(newFilter);
        filterSchedules(newFilter);
    }
    
    const getDataHandler = () => {
        getZonesHandler();
        getSchedulesHandler();
    }

    const getZonesHandler = async () => {
        var venueZones = await getZones(id);
        if (venueZones) {
            setZones(venueZones);
        }
    }

    const getSchedulesHandler = async () => {
        var schedulesRes = await getSchedules(id);
        if (schedulesRes) {
            setSchedules(schedulesRes);
            setFilteredSchedules(schedulesRes);
        }
    }

    const filterSchedules = (filterObject) => {
        var newFilteredSchedules = schedules;
        if (filterObject) {
            if (filterObject.zones?.length) {
                newFilteredSchedules = newFilteredSchedules.filter(schedule => {
                    var result = false;
                    filterObject.zones.forEach(zone => {
                        if (schedule.zones.includes(zone)) {
                            result = true;
                        }
                    })
                    return result;
                })
            }
            if (filterObject.days?.length) {
                newFilteredSchedules = newFilteredSchedules.filter(schedule => {
                    var result = false;
                    filterObject.days.forEach(day => {
                        if (schedule.days.includes(day)) {
                            result = true;
                        }
                    })
                    return result;
                })
            }
        }
        setFilteredSchedules(newFilteredSchedules);
    }

    return <>
        <ViewHeader>
            <TopNavigation to={`../${id}`} />
            <h3>Schedules</h3>
        </ViewHeader>

        <ScheduleMenu zones={zones} customerId={id} refreshSchedules={getSchedulesHandler} filter={filter} setFilter={onSetFilter} />

        <div>
            {filteredSchedules?.map((schedule, index) => {
                return <ScheduleItem
                    key={index}
                    schedule={schedule}
                    zones={zones}
                    refreshSchedules={getSchedulesHandler}
                    customerId={id} />
            })}
        </div>
    </>
}

export default ScheduleView;